// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-button {
  background-color: rgb(184, 184, 202);
  opacity: 0.5;
  padding: 10px;
  border-radius: 10px;
  color:white;
  font-weight: bold;
  border:none;
  min-width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.share-button.modal {
  width: 50%;
}


.share-button.guessable {
  background-color: rgb(184, 184, 202);
  background-color: rgba(31, 27, 250, 0.726);

  opacity: 1;
  border: 2px;
  border-style: solid;
  border-color:rgb(81, 158, 202);
}

.share-button.guessable:hover {
  opacity: .8;
}

.share-button img {
  width: 25px;
  height: 25px;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/ShareButton/ShareButton.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,oCAAoC;EACpC,0CAA0C;;EAE1C,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".share-button {\n  background-color: rgb(184, 184, 202);\n  opacity: 0.5;\n  padding: 10px;\n  border-radius: 10px;\n  color:white;\n  font-weight: bold;\n  border:none;\n  min-width: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.share-button.modal {\n  width: 50%;\n}\n\n\n.share-button.guessable {\n  background-color: rgb(184, 184, 202);\n  background-color: rgba(31, 27, 250, 0.726);\n\n  opacity: 1;\n  border: 2px;\n  border-style: solid;\n  border-color:rgb(81, 158, 202);\n}\n\n.share-button.guessable:hover {\n  opacity: .8;\n}\n\n.share-button img {\n  width: 25px;\n  height: 25px;\n  margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
